/* React */
import React from "react";

/* React Redux */
import { useDispatch } from "react-redux";
import { setInsightsFilterValue } from "src/redux/features/insights-filter/insightsFilterSlice";

/* Ionic */
import { IonItem, IonIcon } from "@ionic/react";
import { close } from "ionicons/icons";

/* Stylesheet */
import styles from "./ChipItem.module.scss";

/* Interfaces */
import { FilterType } from "src/shared/interfaces/insights-filter/InsightsFilter";
import { ChipItemProps } from "src/shared/interfaces/common/QuickFilter";

const ChipItem: React.FC<ChipItemProps> = ({
  filterKey,
  value,
  initialValue,
  disabled,
}) => {
  const dispatch = useDispatch();

  const handleFilterValue = (
    key: FilterType,
    value: string
  ) => {
    dispatch(
      setInsightsFilterValue({ key: key, value: value })
    );
  };

  return (
    <IonItem
      style={{
        "--background": disabled
          ? "var(--ion-color-light)"
          : undefined,
        "--color": disabled
          ? "var(--ion-color-text-primary"
          : undefined,
      }}
      className={styles.chip_item}
      lines="none"
      button
      disabled={disabled}
      onClick={() =>
        handleFilterValue(filterKey!, initialValue!)
      }
    >
      <div className={styles.value}>{value}</div>
      {!disabled ? (
        <IonIcon
          className={styles.icon}
          icon={close}
          slot="end"
        />
      ) : undefined}
    </IonItem>
  );
};
export default ChipItem;
